import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admission-calendar-student',
  templateUrl: './admission-calendar-student.component.html',
  styleUrls: ['./admission-calendar-student.component.scss']
})
export class AdmissionCalendarStudentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
